import { hasTag } from 'utils/gameTags'

const currencyModeDictionary = {
  SC: 'sweepstake',
  GC: 'gold',
} as const

type SupportedCurrencies = keyof typeof currencyModeDictionary

type BingoFilterGame = {
  type?: string
  tags?: string[]
  mode?: string | null
}

type FilterOptions = {
  excludeBingo?: boolean
  onlyBingo?: boolean
}

export const filterBingoGamesByMode = <T extends BingoFilterGame>(
  games: T[] | null | undefined,
  activeCurrency?: string | null,
  options?: FilterOptions,
): T[] => {
  const excludeBingo = options?.excludeBingo
  const onlyBingo = options?.onlyBingo
  const requiredMode = activeCurrency
    ? currencyModeDictionary[activeCurrency as SupportedCurrencies]
    : undefined

  return (
    games?.filter((game) => {
      const isBingoGame = game.type === 'bingo' || hasTag(game.tags, 'bingo')

      if (onlyBingo && !isBingoGame) {
        return false
      }

      if (!onlyBingo && excludeBingo && isBingoGame) {
        return false
      }

      if (!isBingoGame) {
        return true
      }

      if (!requiredMode) {
        return false
      }

      return game?.mode?.toLowerCase() === requiredMode
    }) ?? []
  )
}
